import React from "react";
import "./Client.css";

import clientImage1 from '../../img/user-1.jpg';
import clientImage2 from '../../img/user-2.jpg';

import clientImage3 from '../../img/user-3.jpg';
import clientImage4 from '../../img/user-4.jpg';
import arrow from '../../img/icon-arrow.svg';




// Sample data for the client reviews
const reviews = [
  {
    id: 1,
    name: "Alexander Stone",
    company: "Arno Consulting",
    info:"Overall Experience",
    review:
    "I had an I recently booked a flight through [Booking Website/App], and I couldn’t be happier with the experience.",
    stars: 5,
    image: clientImage1,
  },
  {
    id: 2,
    name: "Benjamin Murphy",
    company: "TechPro Solutions",
    info:"Overall Experience",
    review:
    "I did have a quick question about my itinerry, and customer service was incredibly helpful and responsive",
   stars: 5,
    image: clientImage2,
  },
  {
    id: 3,
    name: "Sophia Anderson",
    company: "CareWell Systems",
    info:"Overall Experience",
    review:"After finally selecting a flight, I was hit with unexpected fees during checkout that weren’t clearly stated upfront.",
    stars: 5,
    image: clientImage3,
  },
  {
    id: 4,
    name: "Noah Brown",
    company:"DigitalSolutions Inc",
    info:"Overall Experience",
    review:"I received my confirmation email almost immediately, and all the details were accurate.",
    stars: 5,
    image: clientImage4,
  },
  
];

export default function Client() {

  const handleReadMoreClick = () => {
    
    window.open("https://g.co/kgs/eKwtKwU", "_blank");
  };

  return (
    <div className="client-container">
      <div className="client-content">
        {/* Left Side - Heading */}
        <div className="client-header">
            <div className="arrow-icon">
                <img src={arrow} alt="" />
            </div>
          <h2>Success stories in their own words</h2>
          <p className="read-review">Read what our satisfied clients have to say about their experiences with our platform.</p>
          <p className="review-customer">
          Trusted by 40K+ customers <br /> <b className="stars">★★★★★</b> <span className="review-ratings">4.4/5.0 (From 3580 Reviews)</span> 
          </p>
          {/* <button className="read-more-btn" onClick={handleReadMoreClick}>
            READ MORE REVIEWS <span className="arrow">🡥</span>
          </button> */}
        </div>

        {/* Right Side - Cards */}
        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
                <div className="client-flex">
                <img src={review.image} className="avatar" />
                <div className="client-info-flex">
                <p className="author-name">{review.name}</p>
                  <p className="author-company">{review.company}</p>
                  </div>
                  </div>
                  <div className="info-client">
                    <p className="info-c">{review.info}</p>
                  </div>
              <p className="review-text">"{review.review}"</p>
              <div className="review-author">
                
               
                <div className="review-stars" style={{ display: 'flex', gap: '20px' }}>
                {"★".repeat(review.stars)}
                <span className="empty-stars">{"☆".repeat(5 - review.stars)}</span>
              </div>
              <div className="review-number">5.0</div>
                  
                
              </div>
              
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
